// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2oy8-","large":"styles_large__3C7TD"};